'use strict';

import NS from 'src/ns';
import forEach from 'lodash/each';
import assign from 'lodash/assign';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isFunction';
import find from 'lodash/find';
import baseMatches from 'lodash/_baseMatches';

var $window = $(window);


/* ============================== Definitions ============================== */

var mediaQueries = {
  'sp': '(max-width: 767px)',
  'tablet': '(min-width: 768px)',
  'pc': '(min-width: 920px)'
};


/* ============================== MatchMedia ============================== */

function MatchMedia() {
  this.entries = [];
  this._onResize();
  $window.on('resize', this._onResize.bind(this));
}


assign(MatchMedia.prototype, /** @lends MatchMedia# */ {
  /**
   * @private
   */
  _onResize: function() {
    this.checkAndTrigger();
  },

  /**
   * media のマッチ状況を調べて必要なコールバックを実行する
   */
  checkAndTrigger: function() {
    var currentArray = [],
        fire = this.fire;

    // 最初に onUnMatch をひと通り発火する
    this.entries.forEach(function(entry, i) {
      var media   = entry.media,
          matches = window.matchMedia(media).matches;

      currentArray[i] = entry.matches;
      entry.matches   = matches;

      if (currentArray[i] && !matches) {
        fire(entry.onUnMatch);
      }
    });

    // 次に onFirstTime, onMatch を発火する
    this.entries.forEach(function(entry, i) {
      var matches = entry.matches;

      if (matches) {
        fire(entry.onFirstTime);

        // 一度きりなので実行後は空に
        entry.onFirstTime = [];
      }
      if (!currentArray[i] && matches) {
        fire(entry.onMatch);
      }
    });
  },

  fire: function(functions) {
    if (isEmpty(functions)) return;

    for (var i = 0; i < functions.length; i++) {
      if (isFunction(functions[i])) {
        functions[i]();
      }
    }
  },

  getEntry: function(name) {
    // return _.findWhere(this.entries, {name: name});
    return find(this.entries, baseMatches({ name: name }));
  },

  /**
   * コールバック関数を登録する
   * @param {string} name media 識別子
   * @param {Object=} opts
   * @param {Function=} opts.onMatch マッチした時に呼び出すコールバック関数
   * @param {Function=} opts.onUnMatch マッチしなくなった時に呼び出すコールバック関数
   * @param {Function=} opts.onFirstTime マッチしたときに一度だけ呼び出すコールバック関数
   * @param {boolean=} opts.noImmediate 登録時にコールバック関数を呼び出さないフラグ
   */
  register: function(name, opts) {
    var entry = this.getEntry(name),
        fire  = this.fire;

    if (!entry && mediaQueries[name]) {
      entry = new MatchMediaEntry(name, mediaQueries[name]);
      this.entries.push(entry);
    }
    if (entry) {
      entry.addCallbacks(opts);
    }
    if (!opts.noImmediate) {
      if (entry.matches) {
        fire(entry.onFirstTime);
        entry.onFirstTime = [];
      }
      if (entry.matches && opts.onMatch) {
        opts.onMatch();
      }
      if (!entry.matches && opts.onUnMatch) {
        opts.onUnMatch();
      }
    }
  },

  /**
   * 現在のマッチ状況を取得する
   * @param {string=} name 取得する media の識別子。指定しない時はすべての media のマッチ状況をオブジェクトで返す。
   * @returns {Object|boolean}
   */
  getMatches: function(name) {
    if (isUndefined(name)) {
      var matches = {};

      for (var i = 0, l = this.entries.length; i < l; ++i) {
        matches[this.entries[i].name] = this.entries[i].matches;
      }
      return matches;
    }
    else {
      var entry = this.getEntry(name);

      if (entry) {
        return entry.matches;
      }
      else {
        return window.matchMedia(mediaQueries[name]).matches;
      }
    }
  }
});


/* ============================== MatchMediaEntry ============================== */

function MatchMediaEntry(name, media, opts) {
  this.name = name;
  this.media = media;
  this.matches = window.matchMedia(this.media).matches;
  this.onMatch = [];
  this.onUnMatch = [];
  this.onFirstTime = [];

  if (opts) {
    this.addCallbacks(opts);
  }
}

assign(MatchMediaEntry.prototype,  /** @lends MatchMediaEntry# */ {
  addCallbacks: function(callbacks) {
    forEach(callbacks, function(val, key) {
      if (this[key]) {
        this[key].push(val);
      }
    }.bind(this));
  }
});


/* ============================== Exports ============================== */

/**
 * @name NS.MatchMedia
 * @type {MatchMedia}
 */
export default NS.MatchMedia = new MatchMedia;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/utility/matchMedia.js